const CREATE_AFFILIATE_REQUEST = 'CREATE_AFFILIATE_REQUEST';
const CREATE_AFFILIATE_REQUEST_SUCCESS = 'CREATE_AFFILIATE_REQUEST_SUCCESS';
const CREATE_AFFILIATE_REQUEST_FAILURE = 'CREATE_AFFILIATE_REQUEST_FAILURE';

export { CREATE_AFFILIATE_REQUEST, CREATE_AFFILIATE_REQUEST_SUCCESS, CREATE_AFFILIATE_REQUEST_FAILURE };



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates_create/redux/constants/create_affiliate.constants.js